import axios from "axios";
import moment from "moment";
import { logoutUser } from "../store/actions/authAction";

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("Authorization");
  }
};
export const getMsgTime = (dateTime) => {
  const messageTime = moment();
  return messageTime.format("DD-MMM h:mm A");

  const currentDate = moment();

  const isCurrentDate = messageTime.isSame(currentDate, "day");

  let formattedDate;

  if (isCurrentDate) {
    //formattedDate = messageTime.format("h:mm A");
    formattedDate = messageTime.format("DD-MM h:mm A");
  } else {
    formattedDate = messageTime.format("DD-MM h:mm A");
  }
  return formattedDate;
};

export const handleSessionExpired = (error, dispatch) => {
  if (
    error?.response?.data?.error?.error_message === "Session has been expired"
  ) {
    dispatch(logoutUser());
    window.location.href = process.env.REACT_APP_LOGIN_URL;
    return true;
  }
  return false;
};
